import { v4 as uuidv4 } from "uuid";
import { Keyword } from "../types/Keyword";
import { Parameter } from "../types/Parameter";

type ParsedContent = {
  Keywords: string[];
  Quantities: [string, number, string][];
};

export function parseOpenAIResponseContent(openAiResponse: string): {
  extractedKeywords: Keyword[];
  extractedParameters: Parameter[];
} {
  let parsedContent: ParsedContent | null = null;
  try {
    const parsedResponse = JSON.parse(openAiResponse);
    const contentString = parsedResponse.choices[0].message.content;

    // Replace single quotes with double quotes for JSON parsing
    const cleanedContentString = contentString
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/[\t\n\v\f\r ]+/g, " ")
      .replace(/([{,])(\s*)(\w+)(\s*):/g, '$1"$3":'); // Add double quotes around keys

    parsedContent = JSON.parse(cleanedContentString);
  } catch (error) {
    console.error("Error parsing content string: ", error);
    return { extractedKeywords: [], extractedParameters: [] };
  }

  if (!parsedContent) {
    return { extractedKeywords: [], extractedParameters: [] };
  }
  // Extract keywords and parameters
  const extractedKeywords: Keyword[] = parsedContent.Keywords.map(
    (keyword: string) => ({
      id: uuidv4(),
      keyword,
    })
  );

  const extractedParameters: Parameter[] = parsedContent.Quantities.filter(
    (result: [string, any, string]) => !isNaN(Number(result[1]))
  ).map((result: [string, number, string]) => ({
    id: uuidv4(),
    key: result[0],
    value: result[1].toString(),
    unit: result[2],
  }));

  return { extractedKeywords, extractedParameters };
}
